import React, {Fragment, useEffect, useState} from "react";
import PreLoader from "../../../share-components/ui/preLoader";
import Breadcrumb from "../../../layout/breadcrumb";
import {Card, CardBody, Col, Container, Form, FormGroup, Input, Row} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import pendingOrderList, {getAllPendingOrderList, getAllPendingOrders} from "../store/pendingOrderSlice";
import moment from "moment/moment";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import {DateRangePicker} from "rsuite";
import AsyncSelect from "react-select/async";
import {mapSearchAutoSuggestion} from "../../../utils/mapper";
import {sellerAutoSuggestionApi} from "../../../services/manage-product/productService";
import {useHistory, Link} from "react-router-dom";

const dataMenu = [
    {
        type: 0,
        text: 'Order',
        link: '/order'
    },
    {
        type: 1,
        text: 'Idle Orders',
        link: ''
    },
];

const customStyles = {
    control: base => ({
        ...base,
        minHeight: 50,
        border: 'none',
    })
};

const PendingOrder = () => {

    const [loading, isSetLoading] = useState(true);
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pendingOrderList = useSelector(getAllPendingOrders);
    const pendingOrderState = useSelector(({order})=> order.pendingOrderList);
    // Preselect the last 3 months (project-wide convention). The live query runs
    // on orders.order_date, so this window renders real data (unlike the old
    // stale-pivot version which blanked on the same default).
    const TodayDate = new Date();
    const threeMonthsAgo = new Date(new Date().setMonth(TodayDate.getMonth() - 3));
    const [dateRange, setDateRange] = useState([threeMonthsAgo, TodayDate]);
    const [startDate, endDate] = dateRange;
    const [tableLoading, isSetTableLoading] = useState(false);
    // Seller filter starts empty → all sellers on first load.
    const [seller, setSeller] = useState(null);
    const { afterToday } = DateRangePicker;
    const [timer, setTimer] = useState(null);
    const [search,setSearch]=useState(null);
    const [trackingAdded, setTrackingAdded] = useState('');
    const [fulfillmentStatus, setFulfillmentStatus] = useState('');
    const [financialStatus, setFinancialStatus] = useState('');
    const [mailCount, setMailCount] = useState('');

    // Pretty-print raw status values for display: "partially_refunded" -> "Partially Refunded".
    const formatStatus = (v) => v ? String(v).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : v;


    useEffect(() => {
        getData();
    }, [dispatch, startDate, endDate, seller, pageSize, page, search, trackingAdded, fulfillmentStatus, financialStatus, mailCount]);

    const getData = () => {
        isSetTableLoading(true);
        const data = {
            page,
            pageSize,
            seller: seller && seller.value ? seller.value : '',
            search
        }
        // Only scope by date when the user actually picks a range.
        if (startDate !== null && endDate !== null) {
            data.start_date = moment(startDate).format('YYYY-MM-DD');
            data.end_date = moment(endDate).format('YYYY-MM-DD');
        }
        if (trackingAdded) data.tracking_added = trackingAdded;
        if (fulfillmentStatus) data.fulfillment_status = fulfillmentStatus;
        if (financialStatus) data.financial_status = financialStatus;
        // mailCount can legitimately be "0", so test against '' not falsy.
        if (mailCount !== '') data.mail_count = mailCount;

        dispatch(getAllPendingOrderList(data)).then(res=>{
            if(!res.error){
                isSetLoading(false);
            }
            isSetTableLoading(false);
        })
    };

    const sellerPromiseOption = (inputValue) =>
        new Promise((resolve) => {
            const data = {
                value: inputValue
            }
            setTimeout(() => {
                resolve(mapSearchAutoSuggestion(sellerAutoSuggestionApi(data)))
            });
        });

    const tableColumns = [
        {
            name: 'Order Number',
            selector: row => row.item_id,
            cell: (row) =><Link className="text-primary" target="_blank" style={{cursor: "pointer"}} to={`${process.env.PUBLIC_URL}/order/${row.order_id}/view`}>{row.item_id}</Link>,
            sortable: true,
            left: true,
        },
        {
            name: 'Seller',
            selector: row => row.seller,
            sortable: true,
            right: false,
        },
        {
            name: 'No. of Mail Requests',
            selector: row => row.count,
            sortable: true,
            center: true,
        },
        {
            name: 'Tracking Added',
            selector: row => row.tracking_added,
            sortable: true,
            center: true,
        },
        {
            name: 'Fulfillment Status',
            selector: row => formatStatus(row.fulfillment_status),
            sortable: true,
            center: true,
        },
        {
            name: 'Financial Status',
            selector: row => formatStatus(row.financial_status),
            sortable: true,
            center: true,
        },
        {
            name: 'Order Date',
            selector: row => row.date,
            sortable: true,
            center: true,
        },
        {
            name: 'Delivery Date',
            selector: row => row.delivery_date,
            sortable: true,
            center: true,
        },
    ];

    const pageChange = (event) => {
        setPage(event)
    }

    const onPageSizeChange=(e)=>{
        setPage(1)
        setPageSize(e)
    }

    const pagination = (e) => {
        setPageSize(e)
    }


    return (
        <Fragment>
            {loading ? <>
                    <PreLoader></PreLoader>
                </>
                :
                <>
                    <Breadcrumb data={dataMenu} title="Idle Orders"/>
                    <Container fluid={true}>
                        <div className="product-grid">
                            <div className="feature-products">
                                <Row>
                                    <Col md={4}>
                                        <div className="dashboard-datepicker ml-2">
                                            <DatePicker
                                                dateRange={dateRange}
                                                dateRangeChange={(date)=>{
                                                    setDateRange(date ? date : [null, null])
                                                }}
                                                disabledDate={afterToday()}
                                            />
                                        </div>
                                    </Col>
                                    
                                    <Col  md={4}>
                                        <AsyncSelect
                                            className="select2-filter"
                                            isClearable={true}
                                            menuPortalTarget={document.body}
                                            defaultOptions
                                            placeholder="select Seller"
                                            value={seller}
                                            // defaultValue={productState.filter.seller}
                                            loadOptions={sellerPromiseOption}
                                            styles={{...customStyles, menuPortal: base => ({ ...base, zIndex: 100 }) }}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            onClear={(e) => {

                                            }}
                                            onChange={(e) => {
                                                setSeller(e);
                                                // setSeller(e ? e.value : null)
                                                // dispatch(setProductFilter({
                                                //     // ...productState.filter,
                                                //     seller: e ? e : null,
                                                //     currentPage: 0
                                                // }));
                                                // clearSelectAll();
                                                // // setSearchSeller(e ? e.value : null);
                                            }}

                                        />
                                    </Col>

                                    <Col md={4}>
                                        <Form>
                                            <FormGroup className="m-0">
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e)=>{
                                                        clearTimeout(timer);
                                                        const newTimer = setTimeout(()=>{
                                                            setSearch(e.target.value);

                                                        },500);
                                                        setTimer(newTimer)


                                                    }}
                                                    placeholder="Search Order"
                                                />
                                                <i className="fa fa-search"></i>
                                            </FormGroup>
                                        </Form>
                                    </Col>

                                    <Col md={3} className="mt-3">
                                        <Input
                                            type="select"
                                            className="form-control"
                                            required
                                            value={trackingAdded}
                                            onChange={(e) => { setPage(1); setTrackingAdded(e.target.value); }}
                                        >
                                            <option value="">Tracking Added (All)</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Input>
                                    </Col>

                                    <Col md={3} className="mt-3">
                                        <Input
                                            type="select"
                                            className="form-control"
                                            required
                                            value={fulfillmentStatus}
                                            onChange={(e) => { setPage(1); setFulfillmentStatus(e.target.value); }}
                                        >
                                            <option value="">Fulfillment Status (All)</option>
                                            <option value="unfulfilled">Unfulfilled</option>
                                            <option value="partial">Partial</option>
                                        </Input>
                                    </Col>

                                    <Col md={3} className="mt-3">
                                        <Input
                                            type="select"
                                            className="form-control"
                                            required
                                            value={financialStatus}
                                            onChange={(e) => { setPage(1); setFinancialStatus(e.target.value); }}
                                        >
                                            <option value="">Financial Status (All)</option>
                                            <option value="paid">Paid</option>
                                            <option value="partially_refunded">Partially Refunded</option>
                                        </Input>
                                    </Col>

                                    <Col md={3} className="mt-3">
                                        <Input
                                            type="select"
                                            className="form-control"
                                            required
                                            value={mailCount}
                                            onChange={(e) => { setPage(1); setMailCount(e.target.value); }}
                                        >
                                            <option value="">No. of Mail Requests (All)</option>
                                            <option value="0">0</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </Input>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mt-4" sm="12">
                                        <Card>
                                            <CardBody>
                                                <div className="table-responsive product-table">
                                                    <CommonDataTable
                                                        noAction
                                                        headerColumns={tableColumns}
                                                        gridData={pendingOrderList}
                                                        paginationTotalRows={pendingOrderState.pendingOrdersDataTableRow}
                                                        paginationServer
                                                        onChangePage={pageChange}
                                                        onChangeRowsPerPage={onPageSizeChange}
                                                        paginationDefaultPage={page}
                                                        paginationPerPage={pageSize}
                                                    />
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Container>
                </>
        }
        </Fragment>
    )
}

export default PendingOrder;